import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getEntryStartRoute, resolveEntryFromUrl } from '../../shared/utils/entry-url.util';

@Component({
  selector: 'bz-reset-entry-redirect',
  template: ''
})
export class ResetEntryRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const entry = resolveEntryFromUrl(window.location.href);
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams.Operation;
    delete queryParams.operation;
    queryParams.Operation = entry;

    this.router.navigate([getEntryStartRoute(entry)], {
      queryParams,
      replaceUrl: true
    });
  }
}